// Chart tokens for the dashboard.
//
// Every plot here shows one series — submission counts — so magnitude is
// carried by bar length and every mark wears the same violet. Shading bars
// darker-where-bigger would double-encode the length the bar already shows.
// Violet clears 4.5:1 against the card surface (gray-800/50 over the page
// gradient), so it stays legible without turning into a saturated block.

export const DATA_HUE = '#a78bfa'; // violet-400
export const DATA_HUE_DIM = 'rgba(167, 139, 250, 0.45)';
export const TRACK = 'rgba(148, 163, 184, 0.12)'; // unfilled meter/bar track
export const GRID = 'rgba(148, 163, 184, 0.16)'; // hairline gridlines, one step off surface

export const formatCount = (value) => Number(value || 0).toLocaleString();

// Compact form for values that share a row with a label (12.9K, 1.2M).
export const formatCompact = (value) => {
  const n = Number(value || 0);
  if (Math.abs(n) < 10000) return n.toLocaleString();
  try {
    return new Intl.NumberFormat(undefined, { notation: 'compact', maximumFractionDigits: 1 }).format(n);
  } catch {
    return n.toLocaleString();
  }
};

// Percentage change vs the previous period. Null when there is no baseline —
// "+100%" off a base of zero says nothing useful.
export const percentChange = (current, previous) => {
  if (!previous) return null;
  return Math.round(((current - previous) / previous) * 100);
};

// Round the axis top up to a clean value that also halves into a whole number,
// since the plot draws a midpoint gridline and submission counts are integers
// ("2.5 submissions" on a tick reads like a bug). Steps stay fine-grained — a
// peak of 6 tops out at 6, not 10, so the tallest bar isn't stranded mid-plot.
export const niceCeil = (value) => {
  const n = Math.max(1, Math.ceil(value));
  if (n <= 10) return n + (n % 2);
  const step = 10 ** Math.floor(Math.log10(n)) / 5; // 2 for tens, 20 for hundreds
  const top = Math.ceil(n / step) * step;
  return Number.isInteger(top / 2) ? top : top + step;
};
